import React, { useCallback } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import Grid from '@material-ui/core/Grid';
import strings from 'strings';
import { TextBox } from 'UI/components/atoms';
import EmailPicker from 'UI/components/molecules/EmailPicker';
import { Endpoints } from 'UI/constants/endpoints';
import { EntityType } from 'UI/constants/entityTypes';
import { VALIDATION_REGEXS } from 'UI/utils';

import { OTHER_INTERVIEWER_FORM_FIELDS_MAP as FORM_FIELDS_MAP } from './OtherInterviewerFields.constants';

const STRINGS = strings.sendoutsV2.form.sections.otherInterviewer;

export const OtherInterviewerFields = () => {
  const { control, errors } = useFormContext();
  const handleControllerChange = useCallback(([, value]) => value, []);

  return (
    <Grid container spacing={1}>
      <Grid item xs={6}>
        <Controller
          name={FORM_FIELDS_MAP.FullName.key}
          control={control}
          defaultValue=""
          as={
            <TextBox
              label={STRINGS.labels.fullName}
              placeholder={STRINGS.labels.fullName}
              error={!!errors[FORM_FIELDS_MAP.FullName.key]}
              errorText={errors[FORM_FIELDS_MAP.FullName.key]?.message}
            />
          }
          onChange={handleControllerChange}
          onChangeName="onChange"
          valueName="value"
        />
      </Grid>
      <Grid item xs={6}>
        <Controller
          name={FORM_FIELDS_MAP.Email.key}
          control={control}
          defaultValue=""
          rules={{
            pattern: {
              value: VALIDATION_REGEXS.EMAIL,
              message: STRINGS.errors.invalidEmail
            }
          }}
          as={
            <TextBox
              label={STRINGS.labels.email}
              placeholder={STRINGS.labels.email}
              error={!!errors[FORM_FIELDS_MAP.Email.key]}
              errorText={errors[FORM_FIELDS_MAP.Email.key]?.message}
            />
          }
          onChange={handleControllerChange}
          onChangeName="onChange"
          valueName="value"
        />
      </Grid>
      <Grid item xs={12}>
        <Controller
          name={FORM_FIELDS_MAP.CarbonCopy.key}
          control={control}
          defaultValue={[]}
          as={
            <EmailPicker
              placeholder={STRINGS.labels.carbonCopy}
              label={STRINGS.labels.carbonCopy}
              error={!!errors[FORM_FIELDS_MAP.CarbonCopy.key]}
              errorText={errors[FORM_FIELDS_MAP.CarbonCopy.key]?.message}
              endpoint={Endpoints.Search}
              typeaheadParams={{
                entityType: EntityType.HiringAuthority,
                inColumns: ['ha.work_email']
              }}
              maxItems={10}
              allowNewItems
            />
          }
          onChange={handleControllerChange}
          onChangeName="onSelect"
          valueName="selectedValue"
        />
      </Grid>
    </Grid>
  );
};
